import { useBookingStore } from "@stores/useBookingStore";
import { Input } from "@thetreep/ui";
import { t } from "i18next";
import { create } from "@bufbuild/protobuf";
import { useEffect, useState } from "react";
import {
  PlacementWishSchema,
  SeatReferenceSchema,
} from "@gen/travel/v1/cart_pb";

type PlacementNextRelativesProps = {
  onConfirm: () => void;
  segmentId: string;
};

export default function PlacementNextRelatives({
  onConfirm,
  segmentId,
}: PlacementNextRelativesProps) {
  const [coachValue, setCoachValue] = useState<string>();
  const [seatNumberValue, setSeatNumber] = useState<string>();
  const { addPlacementWish } = useBookingStore();

  const onChange = () => {
    const place = create(SeatReferenceSchema, {
      coach: coachValue,
      seatNumber: seatNumberValue,
    });
    addPlacementWish(
      create(PlacementWishSchema, {
        segmentId: segmentId,
        wish: {
          case: "closeTo",
          value: place,
        },
      }),
    );
    onConfirm();
  };

  useEffect(() => onChange, [coachValue, seatNumberValue]);

  return (
    <>
      <div className="lg:flex items-center">
        <div className="flex flex-col md:mr-4 w-full md:w-1/2">
          {
            <Input
              type="number"
              min={0}
              label={t("placement.carNumber")}
              placeholder={t("placement.carNumber")}
              value={coachValue}
              onChange={(e) => setCoachValue(e.target.value)}
              name="coach"
            />
          }
        </div>
        <div className=" flex flex-col md:ml-4 w-full md:w-1/2">
          {
            <Input
              type="number"
              min={0}
              label={t("placement.placeNumber")}
              placeholder={t("placement.placeNumber")}
              value={seatNumberValue}
              onChange={(e) => setSeatNumber(e.target.value)}
              name="coach"
            />
          }
        </div>
      </div>
    </>
  );
}
